import { useEffect, useState } from "react";

export default function SplashScreen() {
  const [url, setUrl] = useState(null);
  const [hide, setHide] = useState(false);

  useEffect(() => {
    if (window.innerWidth >= 768 || sessionStorage.getItem("splash-shown")) return;
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/settings/public`).then((r) => r.json()).then((s) => {
      if (!s.splash_mobile_url) return;
      sessionStorage.setItem("splash-shown", "1");
      setUrl(s.splash_mobile_url);
      setTimeout(() => setHide(true), 1500);
      setTimeout(() => setUrl(null), 1900);
    }).catch(() => {});
  }, []);

  if (!url) return null;
  return (
    <div data-testid="splash-screen" className="fixed inset-0 z-[100] bg-white transition-opacity duration-300" style={{ opacity: hide ? 0 : 1 }}>
      <img src={url} alt="" className="w-full h-full object-cover" />
    </div>
  );
}
